<template>
    <div>
        <entity-overview entity-type="Stock"></entity-overview>
    </div>
</template>
<style scoped>
</style>
<script>
    import { mapActions } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
        };
    }
    export default {
        name: "StockView",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
        },
        computed: {
            entity() {
                return this.$constants.entities["Stock"];
            },
        }
    };
</script>